export default __webpack_public_path__ + "static/media/home-banner-mobile.6daa0981.webp";